import { LoopbackHttpTransport } from '@workflow-solutions/ofs-vuex-crud';
import axios from 'axios';

const httpClient = axios.create({ withCredentials: true });

class ConnectHttpProviderInstance extends LoopbackHttpTransport {
	constructor() {
		super({ apiBase: window.$config.connectApiBase }, httpClient);
	}
}

const providerInstance = new ConnectHttpProviderInstance();

export default providerInstance;
